import { useEffect }              from 'react'
import { _bootstrap }             from 'state/store.bootstrap'
import { _project }               from 'state/store.projects'
import { _isometry }              from 'state/store.isometry'
import { active_project }         from 'state/store.global'
import { useFetch }               from 'hooks/fetch/useFetch'
import { useGet, setFocus, get }  from 'state/jotai'
import { array }                  from 'utilities/utility.misc'
import { preloadImage }           from 'utilities/utility.images'
import { ISO_FRAMES, ISO_CONFIG } from 'api/api'
import { _lowerQualityIsometry }  from 'state/store.lowerQualityIsometry'

export const PreloadFrames_Poly = () => {

  const { pin, pid } = useGet(active_project)

  const type   = useGet(_bootstrap).type
  const cache  = useGet(_isometry).status
  const poly   = type === 'poly'
  const file   = poly ? 'main/Poly/PolyPreloadFrames.jsx' : ''
  const url    = pid ? ISO_CONFIG : null
  const config = useFetch({ url: poly ? url : null, file }).D

  const lowQualityFrameStatus  = get(_lowerQualityIsometry, 'status')
  const lowQualityFramePercent = get(_lowerQualityIsometry, 'percent')

  const setFrames  = setFocus(_isometry, 'frames')
  const setPercent = setFocus(_isometry, 'percent')
  const setStatus  = setFocus(_isometry, 'status')
  const setConfig  = setFocus(_isometry, 'config')

  useEffect(() => {
    const shouldWait     = config?.[pin]?.SHOULD_LOOK_FOR_LOWER_QUALITY
    const lowQualityDone = lowQualityFramePercent === '100' && lowQualityFrameStatus === 'DONE'

    if (
      poly &&
      config &&
      ((shouldWait && lowQualityDone) || !shouldWait) &&
      pin >= 0 &&
      !['FETCHING', 'DONE'].includes(cache[pin][pid])
    ) {
      const x       = config[pin]
      const PATH    = x.PNG_PATH
      const NUM     = x.IMAGE_NUM
      const IMG_INI = x.FIRST_IMAGE
      const IMG_END = x.LAST_IMAGE
      const INI     = x.START_IMAGE
      const SNP     = x.IMAGE_SNAPFRAMES
      const EXT     = x.FILE_EXT

      const FNC = i => {
        if (INI + i > IMG_END) {
          return `${ISO_FRAMES}${PATH}/${Math.abs(IMG_END - (INI + i)) + IMG_INI - 1}.${EXT}`
        } else {
          return `${ISO_FRAMES}${PATH}/${i + INI}.${EXT}`
        }
      }

      const COL = array(NUM, FNC, SNP)

      setConfig ( a => a?.map((d, i) => fn(d, i, pin, pid, x)))
      setPercent( a => a?.map((d, i) => fn(d, i, pin, pid, '0')))
      setStatus ( a => a?.map((d, i) => fn(d, i, pin, pid, 'FETCHING')))

      const loadAll = async () => {
        const ARR       = new Array(NUM)
        let loadedCount = 0
        const BATCH     = 8 // up from 2 — saturates browser's 6-per-domain + HTTP/2 multiplexing

        for (let start = 0; start < COL.length; start += BATCH) {
          const chunk = COL.slice(start, start + BATCH)

          await Promise.all(
            chunk.map(async (val, chunkIdx) => {
              const idx = start + chunkIdx
              try {
                const bitmap = await preloadImage(val) // fetch→blob→createImageBitmap, single decode
                ARR[idx]     = { [IMG_INI + idx]: bitmap }
              } catch {
                ARR[idx]     = { [IMG_INI + idx]: null }
                console.warn('❌ failed:', val, 'idx:', idx)
              }

              loadedCount += 1
              const percent = Math.min(100, Math.floor((loadedCount / NUM) * 100)).toFixed()
              setPercent(a => a?.map((d, i) => fn(d, i, pin, pid, percent)))
            })
          )
        }

        setFrames(a => a?.map((d, i) => fn(d, i, pin, pid, ARR)))
        setStatus(a => a?.map((d, i) => fn(d, i, pin, pid, 'DONE')))
      }

      loadAll()
    }
  }, [poly, config, pin, pid, lowQualityFramePercent, lowQualityFrameStatus])

  return null
}

const fn = (x, y, z, v, w) => (y === z) ? { [v]: w } : x